module.exports = __webpack_public_path__ + "static/media/leaf_get_out_right_now_its_the_end_of_you_and_me.a2dc5d96.svg";